import { useMutation } from '@apollo/client/react'
import { AdminAPI, GraphQL } from '@guestgoodie/graphql'
import { useCallback } from 'react'

export function useSync(type: GraphQL.SyncableObject) {
  const [sync, { loading }] = useMutation(AdminAPI.integration.SYNC_FEATURE)

  const syncType = useCallback(() => {
    sync({
      variables: {
        type
      }
    })
  }, [sync, type])

  return {
    sync: syncType,
    loading
  }
}
